module.exports = __webpack_public_path__ + "img/album10_11.331379f1.jpg";